import { useMemo } from "react";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useGetHtmlApiQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { getLastUpdatedOn } from "../../Utils/apiFunctions";

const ScreenReaderAccess = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();

  const { data: screenReaderData = {}, isLoading: screenReaderAccessLoading } =
    useGetHtmlApiQuery({ url: 1208, lang: languageType });

  const { data: lastUpdatedOnData = [], isLoading: lastUpdatedIsLoading } =
    useGetProtectedApiDataQuery({
      url: "basic_page",
      lang: languageType,
    });
  const lastUpdatedOn = useMemo(
    () => getLastUpdatedOn(lastUpdatedOnData, 1208),
    [lastUpdatedOnData],
  );

  if (screenReaderAccessLoading) {
    return <Loader />;
  }

  const pageBody = screenReaderData?.body?.[0]?.processed || "";

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("Screen Reader Access", "स्क्रीन रीडर एक्सेस")}
        titleLink="/screen-reader"
        levelTwo={false}
        levelThree={false}
        isActive={getText("Screen Reader Access", "स्क्रीन रीडर एक्सेस")}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container about_inntxt">
            <div className="row">
              <div className="container">
                <div dangerouslySetInnerHTML={{ __html: pageBody }} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-4">
        <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
      </div>
    </>
  );
};

export default ScreenReaderAccess;
